import { getMostRelevantBenefit } from 'Modules/currentUser/services';
import { BenefitEntity } from 'Modules/currentUser/services/getMostRelevantBenefit';

export default function hasHireExpectedBenefits(userExpectedBenefits: BenefitEntity[]) {
  const talentPoolTargetExpectedBenefits = [
    'expect_recruit_apprentices',
    'expect_recruit_graduates',
  ];
  const userMostRelevantExpectedBenefit = getMostRelevantBenefit(userExpectedBenefits);
  return talentPoolTargetExpectedBenefits.includes(userMostRelevantExpectedBenefit);
}
